import type en from "../en/credits";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  wallet: "المحفظة",
  subtitle: "اشترِ الرصيد عند الحاجة. بدون باقة شهرية.",
  available: "المتاح",
  credits: "رصيد",
  creditsCount: "{n} رصيد",
  creditsCount_one: "رصيد واحد",
  purchased: "المشترى",
  spent: "المستهلك",
  lowBalance: "الرصيد منخفض. يُرجى إضافة رصيد.",
  addCredit: "إضافة رصيد",
  addCreditDescription: "اختر باقة. الرصيد لا تنتهي صلاحيته ويُستخدم في جميع متاجرك.",
  noPacks: "لا توجد باقات رصيد متاحة حاليًا.",
  noPacksDescription: "تواصل مع الدعم إذا احتجت إلى رصيد إضافي.",
  popular: "★ الأكثر شيوعًا",
  bestValue: "💎 أفضل قيمة",
  bonusLine: "+{bonus} مكافأة · {percent}٪",
  totalCreditsSr: "{n} رصيد إجمالًا",
  selectPack: "اختيار باقة {label}",
  summary: "{price} = {credits} رصيد",
  summaryBonus: "{price} = {credits} رصيد (يشمل {bonus} مكافأة)",
  buy: "شراء الرصيد",
  redirecting: "جارٍ فتح صفحة الدفع الآمن…",
  securePayment: "دفع آمن عبر Stripe. يُضاف الرصيد فور تأكيد الدفع.",
  purchaseUnavailable: "الشراء عبر الإنترنت غير متاح بعد — تواصل مع الدعم لإضافة رصيد.",
  contactSupport: "تواصل مع الدعم",
  choosePack: "اختر باقة رصيد.",
  successTitle: "تم استلام الدفع",
  successBody: "تمت إضافة الرصيد إلى محفظتك.",
  pendingTitle: "جارٍ تأكيد الدفع…",
  pendingBody: "سيظهر رصيدك هنا فور اعتماد الدفع. يمكنك تحديث الصفحة بعد لحظات.",
  problemBody: "لم نتمكن من تأكيد هذا الدفع تلقائيًا. إذا تم خصم المبلغ، تواصل مع الدعم وسنحل الأمر.",
  cancelled: "تم إلغاء الدفع. لم يُخصم أي مبلغ.",
  thisMonth: "هذا الشهر",
  planIncludes: "تتضمن باقة {plan} حصة شهرية مجانية. بعدها يُدفع الاستخدام بالرصيد.",
  usagePrompts: "طلبات الذكاء الاصطناعي",
  usageCallMinutes: "دقائق المكالمات الصوتية",
  usageImages: "صور الذكاء الاصطناعي",
  usedThisMonth: "{used} مستخدم هذا الشهر",
  unlimitedFree: "غير محدود (مجاني)",
  freeForEveryone: "مجاني للجميع حاليًا — لا يُستهلك أي رصيد.",
  pricing: "التكلفة",
  costPrompt: "طلب ذكاء اصطناعي",
  costPromptHint: "بالجودة المتوسطة",
  costCall: "مكالمة صوتية، لكل دقيقة",
  costImage: "صورة ذكاء اصطناعي",
  costTranslation: "ترجمة آلية، لكل عنصر",
  free: "مجاني",
  levels: "مستويات الجودة",
  levelsHint: "تكلفة الطلبات والمكالمات أعلى في مستويات الجودة الأعلى.",
  level_low: "منخفض",
  level_medium: "متوسط",
  level_high: "مرتفع",
  level_max: "أقصى",
  multiplier: "×{n}",
  notOnPlan: "غير مشمول في باقتك",
  history: "السجل",
  historyDescription: "آخر 50 حركة على رصيدك.",
  noHistory: "لا يوجد نشاط بعد",
  noHistoryDescription: "ستظهر هنا عمليات الشراء واستخدام الذكاء الاصطناعي.",
  colDescription: "الوصف",
  colCredits: "الرصيد",
  colBalance: "الرصيد بعد العملية",
  kind_signup: "رصيد الترحيب",
  kind_purchase: "شراء رصيد",
  kind_spend: "استخدام الذكاء الاصطناعي",
  kind_refund: "استرداد",
  kind_admin: "تعديل من المنصة",
  feature_prompt: "طلب ذكاء اصطناعي",
  feature_call: "مكالمة صوتية",
  feature_image: "صورة ذكاء اصطناعي",
  feature_translation: "ترجمة آلية",
  chipLabel: "رصيد الذكاء الاصطناعي: {count}. فتح المحفظة",
  chipLowLabel: "رصيد الذكاء الاصطناعي منخفض: {count}. أضف رصيدًا",
  bannerLow: "⚡ تبقّى {n} رصيد — اشحن لمواصلة البناء",
  bannerLow_one: "⚡ تبقّى رصيد واحد — اشحن لمواصلة البناء",
  bannerEmpty: "نفد رصيدك — أضف رصيدًا للمتابعة",
  bannerCta: "إضافة رصيد ←",
  dismiss: "إخفاء",
};

export default ar;
